export default __webpack_public_path__ + "static/media/retro_tools_transparent_-_resources_page-removebg-preview (1).f228a690.png";